import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateMasterService } from '../../template-master.service';
import { MatSnackBar } from '@angular/material/snack-bar';

interface Page {
  pageName?: string;
}
@Component({
  selector: 'app-create-new-page',
  templateUrl: './create-new-page.component.html',
  styleUrls: ['./create-new-page.component.scss']
})
export class CreateNewPageComponent {
  constructor(
    public dialogRef: MatDialogRef<CreateNewPageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private templateMasterService: TemplateMasterService
  ) {
    this.getScreenSize();
  }

  srcHeight: any;
  srcWidth: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.srcHeight = window.innerHeight;
    this.srcWidth = window.innerWidth;
  }

  pageList: any[] = [];
  pageListIndividual: any
  filteredPageList: any[] = [];
  ngOnInit() {
    this.subId = window.localStorage.getItem('subIndustryId');
    this.getAllPage();
  }
  industryWisePages: any[] = [];
  filteredPages: any[] = [];
  getPagesFilter() {
    const uniquePageNames = this.pageListIndividual.reduce((acc: string[], p: Page) => {
      const name = p.pageName?.trim();
      if (name && !acc.includes(name)) {
        acc.push(name);
      }
      return acc;
    }, []);

    this.industryWisePages = uniquePageNames.length > 0
      ? uniquePageNames.map(name => ({ name, status: false }))
      : [];
    this.filteredPages = [...this.industryWisePages]
  }
  subId: any;
  pageSearch: string = '';
  selectedPage: any;
  searchPage() {
    if (this.pageSearch.length != 0) {
      this.filteredPages = this.industryWisePages.filter((page: any) => page.name.includes(this.pageSearch))
    }
    else {
      this.filteredPages = this.industryWisePages
    }
  }
  getSelectedPages(ev: any) {
    if (ev.value.length > 0) {
      const pageList = this.pageListIndividual;
      this.filteredPageList = [];
      let selectedPages = ev.value
      selectedPages.forEach((pageName: any) => {
        pageList.filter((page: any) => {
          if (page.pageName === pageName.name)
            this.filteredPageList.push(page)
        })
      })
    }
    else {
      this.filteredPageList = [...this.pageListIndividual]
    }
  }
  getAllPage() {
    this.templateMasterService.pageNameCategory(this.subId).subscribe((res: any) => {
      this.pageList = res.data;
      const dynamicKey = Object.keys(this.pageList)[0];
      this.pageListIndividual = this.pageList[dynamicKey]
      this.filteredPageList = [...this.pageListIndividual]
      if (this.pageList[dynamicKey].length > 0) {
        this.getPagesFilter();
      }
    })
  }

  closeBtn() {
    this.dialogRef.close();
  }

  addBlankPage() {
    this.dialogRef.close({ page: { name: 'Blank Page' } });
  }

  addPage(page: any) {
    this.dialogRef.close({ page: page });
  }
}
